import { Box, Grid2, Typography } from "@mui/material";
import TextReadMoreLess from "./TextReadMoreLess";
import CustomIcon from "../CustomIcon";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";
import { getStatusDisplay, NON_OPERATIONAL } from "../../Helper/OperationalStatus/statusOptions";

const SingleEntityUpdatedStatus = ({ deviceId, status, reason, comment }) => {

    const showReason = status === NON_OPERATIONAL;
    const { label: statusLabel, color: statusColor } = getStatusDisplay(status);
    const { baseEntityTypeIDLable } = useBaseEntityInfo();

    return (
        <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <Box sx={{ bgcolor: '#3D4B5A', width: '17px', height: '18px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%', paddingLeft: '1px' }}>
                    <CustomIcon name="down-arrow-icon" />
                </Box>
            </Box>
            <Box sx={{ border: '1px solid #E6E6E6', borderRadius: 2, px: 2, py: 1.5, mb: 1 }}>
                <Box sx={{ mb: 1 }}>
                    <Typography variant="fw600s16c000000" sx={{ lineHeight: '24px' }}>After Update</Typography>
                </Box>
                <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                    <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}> {baseEntityTypeIDLable} </Typography>
                    <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>{deviceId}</Typography>
                </Grid2>
                <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                    <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px', fontWeight: 500 }}>Current Status:</Typography>
                    <Grid2 container gap={0.5} alignItems={'center'}>
                        <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px', fontWeight: 500, color: statusColor }}>{statusLabel}</Typography>
                    </Grid2>
                </Grid2>
                {showReason && (
                    <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                        <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>Reason:</Typography>
                        <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px', fontWeight: 400 }}>{reason}</Typography>
                    </Grid2>
                )}
                <Grid2 container flexDirection={'column'} justifyContent={'space-between'} mb={0.5}>
                    <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>Comments:</Typography>
                    <TextReadMoreLess text={comment || '-'} />
                </Grid2>
            </Box>
        </Box>
    )
}

export default SingleEntityUpdatedStatus;
